import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "components/Common/DeleteModal"
import {
  deleteItemCategory,
  exportItemCategories,
  getItemCategories,
} from "store/item-category/item-category-action"
import ItemCategoryListComponent from "components/ItemCategory/list"

const ItemCategoryList = () => {
  // Meta Title
  document.title = "Item Categories"

  const dispatch = useDispatch()
  const { data, error, loading, exportStatus } = useSelector(
    state => state.itemCategory
  )
  const [deleteModal, setDeleteModal] = useState(false)
  const [itemCategory, setItemCategory] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })

  // Handle Category deletion and close the delete modal
  // Dispatch delete action for the selected Category
  // Close the delete modal
  const handleDeleteFunc = data => {
    if (itemCategory) {
      dispatch(deleteItemCategory(itemCategory.id))
    }
    setDeleteModal(false)
  }

  // Set the Category to be deleted and open the delete modal
  // Store the selected Category for deletion
  // Open the delete confirmation modal
  const onClickDelete = data => {
    setItemCategory(data)
    setDeleteModal(true)
  }

  // Fetches new activity logs when a page number is clicked
  const onPageClick = link => {
    dispatch(getItemCategories(link.url, pageNumber, according, search))
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // fetch new categories based when search changed
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      dispatch(getItemCategories(undefined, undefined, undefined, search))
    }, 1500)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  // fetch new categories based when page Number or accroding changed
  useEffect(() => {
    dispatch(getItemCategories(undefined, pageNumber, according, search))
  }, [pageNumber, according])

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportItemCategories(search))
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFunc}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Breadcrumbs title={"Admin"} breadcrumbItem={"Item Category"} />
      <ItemCategoryListComponent
        data={data}
        error={error}
        loading={loading}
        onClickDelete={onClickDelete}
        handleDeleteFunc={handleDeleteFunc}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
      />
    </React.Fragment>
  )
}

export default ItemCategoryList
